export const COMPONENT_TYPES = {
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  MULTI_TILES: 'multi-tiles',
} as const
